<template>
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">百度人像相似度设置</div>
      <el-form-item label="appId">
        <el-input v-model="form.appId" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="apikey">
        <el-input v-model="form.apikey" type="password" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="secretKey">
        <el-input v-model="form.secretKey" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="默认相似度">
        <el-input v-model="form.default" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="状态">
        <el-radio-group v-model="form.is_open">
          <el-radio label="0">关闭</el-radio>
          <el-radio label="1">开启</el-radio>
        </el-radio-group>
        <div style="color:#ff6f06">注：如开启则显示百度人像相似度设置，关闭则不显示</div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

  </div>
</template>

<script>
import SettingApi from "@/api/setting.js";

export default {
  data() {
    return {
      /*form表单数据*/
      form: {
        appId: "", //accessKeyId
        apiKey: "", //accessKeySecret
        secretKey: "",
        default: '',
        is_open: "0"
      },
      loading: false
    };
  },
  created() {
    this.getData();
  },

  methods: {
    getData() {
      let self = this;
      SettingApi.BaiDuSimilar({}, true)
        .then(data => {
          let vars = data.data.vars.values;
          self.form = data.data.vars.values;
        })
        .catch(error => { });
    },
    //提交表单
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      SettingApi.editBaiDuSimilar(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，设置成功",
            type: "success"
          });
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/baidurenxiang/index.vue